import $ from "jquery";

// describe and create object
class MegaNav {
  constructor() {
    this.show_mega_nav = $(".header .menu-item-has-children");
    this.events();
  }

  // events for triggering function
  events() {
    this.show_mega_nav.on("mouseover", this.addClass);
    this.show_mega_nav.on("mouseout", this.removeClass);
  }

  // method/function

  addClass() {
    $(".header").addClass("mega-menu-active");
    $(this).addClass("sub-nav-active");
  }

  removeClass() {
    $(".header").removeClass("mega-menu-active");
    $(this).removeClass("sub-nav-active");
  }
}

export default MegaNav;
